import Img from "components/atoms/Img";
import Title from "components/atoms/Title";

const ContactUsPrivacyPolicy = ({ dataContactUs }) => {
  return (
    <>
      <section id="contact-us">
        <div className="container">
          <Title
            text={"Contact Us"}
            className="mb-6 text-bbc-30px font-semibold capitalize text-bbc-brand-800"
          />
          {dataContactUs.description && (
            <p className="mb-10">{dataContactUs.description}</p>
          )}
          <div className="flex flex-col rounded-md bg-white px-4 py-6 shadow-[0px_9px_24px_rgba(196,196,196,0.25)] lg:grid-rows-[auto_52px_1fr_auto_auto] lg:px-6">
            <Title
              text={dataContactUs.companyName}
              className="mb-4 text-2xl font-semibold leading-9 text-bbc-brand-700"
            />
            {dataContactUs.registered && (
              <p className="mb-4">
                Registered No: {dataContactUs.registered}
                <br />
                D-U-N-S Number {dataContactUs.duns}.
              </p>
            )}
            <div className="mb-4 flex items-center">
              <Img
                src="/assets/icons/location-white.svg"
                width={48}
                height={48}
                wrapper={{ className: "flex-none w-12 mr-3" }}
              />
              {dataContactUs.ggMaps ? (
                <a
                  className="block hover:text-bbc-brand-600"
                  href={dataContactUs.ggMaps}
                  rel="nofollow noreferrer"
                  target="_blank"
                >
                  {dataContactUs.location}
                </a>
              ) : (
                <p>{dataContactUs.location}</p>
              )}
            </div>
            <div className="mb-4 flex items-center">
              <Img
                src="/assets/icons/earth-white.svg"
                width={48}
                height={48}
                wrapper={{ className: "flex-none w-12 mr-3" }}
              />
              <p>
                <a
                  className=" hover:text-bbc-brand-600"
                  href="mailto:private@bbcincorp.com"
                  rel="nofollow"
                >
                  private@bbcincorp.com
                </a>
                &nbsp;or&nbsp;
                <br className="inline md:hidden" />
                <a
                  className=" hover:text-bbc-brand-600"
                  href="mailto:service@bbcincorp.com"
                  rel="nofollow"
                >
                  service@bbcincorp.com
                </a>
              </p>
            </div>
            <div className="flex items-center gap-x-2.5">
              <Img
                src="/assets/icons/phone-white.svg"
                width={48}
                height={48}
                wrapper={{ className: "flex-none w-12" }}
              />
              <a
                className="block hover:text-bbc-brand-600"
                href={`tel:${dataContactUs.phoneNumber}`}
                rel="nofollow"
              >
                {dataContactUs.phoneText}
              </a>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ContactUsPrivacyPolicy;
